import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MessageImage } from '../models/message-image.model';

@Injectable({
  providedIn: 'root',
})
export class MessageImageService {
  endpointUrl: string = environment.apiUrl + '/message-image';

  constructor(private http: HttpClient) {}

  deleteImage(image: MessageImage) {
    return this.http
      .delete<MessageImage>(`${this.endpointUrl}/${image.id}`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(errMsg); // log to console instead
    return throwError(() => errMsg);
  }
}
